var _line, _path, _path2, _path3, _path4, _path5, _path6, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _circle, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersHeroEmptyStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 94,
    viewBox: "0 0 119 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 85.5,
    x2: 114,
    y2: 85.5,
    stroke: "#9097A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 89L105 89",
    stroke: "#9097A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0105 26.6421C41.6009 25.2911 40.3176 24.5 38.8045 24.5C37.2393 24.5 35.9175 25.3478 35.5273 26.7633C34.6645 29.8931 33.5 36.3672 33.5 48.5C33.5 57.682 35.7796 64.2709 38.1573 68.6489C40.8212 73.5541 46.4516 75.5 52.2142 75.5C52.8245 75.5 53.4002 75.1779 53.9044 74.5767C54.4097 73.9742 54.8079 73.128 55.0429 72.1974C55.2775 71.2685 55.3408 70.289 55.2063 69.4353C55.071 68.5759 54.7451 67.8959 54.2521 67.4884C48.8892 63.0551 44.2335 56.81 44.2335 48.5C44.2335 36.1977 42.9428 29.7168 42.0106 26.6421L42.489 26.4971L42.0105 26.6421Z",
    fill: "#585D66",
    stroke: "#9097A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6299 25.1076C40.5492 25.0291 40.4408 25 40.3283 25C39.9075 25 39.5801 25.3948 39.6396 25.8112C39.9146 27.7345 40.5 33.5807 40.5 48.5C40.5 60.5777 44.528 64.983 47.5943 66.5868C49.6712 67.6731 52.1202 67.9761 54.2773 68.8928C56.1459 69.687 56.2633 69.581 54.6408 68.3604C48.9673 64.0921 44 57.7219 44 48.5C44 29.4889 41.2634 25.7244 40.6299 25.1076Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3603 22.6359C52.6632 20.2541 54.7035 18.5 57.1197 18.5C59.6356 18.5 61.7438 20.403 62.0005 22.9058L63.5005 37.5301L64.4348 89.3885C64.4618 90.8844 63.0581 91.9991 61.6048 91.6358C58.5845 90.8808 55.4202 90.8796 52.3998 91.6347C50.9409 91.9994 49.5468 90.8966 49.5805 89.4059C49.8282 78.4454 50.5856 45.8013 50.9994 37.525C51.283 31.8521 51.8897 26.3373 52.3603 22.6359Z",
    fill: "#1A1B1D",
    stroke: "#9097A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0243 21.9841C53.2798 20.2529 54.7739 19 56.5239 19C56.7827 19 56.9886 19.217 56.9749 19.4755L56 37.98L56.9556 87.692C56.9818 89.0526 56.0888 90.2603 54.7803 90.6342L52.6199 91.2515C51.3213 91.6225 50.0355 90.6426 50.071 89.2925C50.3276 79.5272 51.2077 46.2578 51.5 37.98C51.7243 31.6302 52.5071 25.4875 53.0243 21.9841Z",
    fill: "#585D66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.622 27.9672C74.7911 26.5551 75.9885 25.5 77.4158 25.5C78.5777 25.5 79.6002 26.2016 79.9663 27.2779C81.2044 30.9175 83.5 38.6861 83.5 46.2019C83.5 51.281 80.5073 57.181 77.4694 61.8428C74.1448 66.9444 68.2098 69.5 62.0435 69.5C61.5471 69.5 61.0674 69.2091 60.6426 68.6236C60.219 68.0396 59.8977 67.2199 59.7294 66.3304C59.5615 65.4428 59.5535 64.5249 59.7215 63.7579C59.8915 62.9821 60.2235 62.4314 60.6714 62.159C66.5735 58.5692 71.7062 53.6343 72.4303 47.1226C73.5415 37.1288 74.2429 31.1325 74.622 27.9672Z",
    fill: "#1A1B1D",
    stroke: "#9097A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78.9293,
    y1: 32.505,
    x2: 85.9293,
    y2: 31.505,
    stroke: "#9097A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 72.3051,
    y1: 32.6039,
    x2: 77.9067,
    y2: 36.9192,
    stroke: "#9097A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 48.3051,
    y1: 51.6039,
    x2: 53.9067,
    y2: 55.9192,
    stroke: "#9097A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 82.2796,
    y1: 46.4145,
    x2: 78.2795,
    y2: 49.1126,
    stroke: "#9097A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 53.2051,
    y1: 79.456,
    x2: 47.205,
    y2: 82.1541,
    stroke: "#9097A3"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 64.2796,
    y1: 24.4145,
    x2: 60.2795,
    y2: 27.1126,
    stroke: "#9097A3"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 47.2796,
    y1: 62.4145,
    x2: 43.2795,
    y2: 65.1126,
    stroke: "#9097A3"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 44.8042,
    y1: 29.6712,
    x2: 42.0116,
    y2: 33.6059,
    stroke: "#9097A3"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 69.472,
    y1: 48.8351,
    x2: 71.8047,
    y2: 55.5103,
    stroke: "#9097A3"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 53.472,
    y1: 32.8351,
    x2: 55.8047,
    y2: 39.5103,
    stroke: "#9097A3"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 30.2213,
    y1: 55.3187,
    x2: 36.5555,
    y2: 58.4615,
    stroke: "#9097A3"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 31.2222,
    y1: 35.5521,
    x2: 37.5565,
    y2: 38.6949,
    stroke: "#9097A3"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 41.0112,
    y1: 48.2417,
    x2: 46.7361,
    y2: 44.0912,
    stroke: "#9097A3"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 60.7065,
    y1: 47.7456,
    x2: 66.4314,
    y2: 43.5952,
    stroke: "#9097A3"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 75.6081,
    y1: 61.0409,
    x2: 82.6675,
    y2: 60.6359,
    stroke: "#9097A3"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 60.9714,
    y1: 76.9061,
    x2: 68.0308,
    y2: 76.5012,
    stroke: "#9097A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.351,
    cy: 13.3183,
    r: 9.77778,
    transform: "rotate(15.0018 107.351 13.3183)",
    fill: "#1A1B1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.82 22.7631C110.036 24.1609 115.398 21.0656 116.795 15.8495C118.193 10.6335 115.098 5.27186 109.882 3.87405C109.144 3.67618 108.402 3.56835 107.67 3.54381C111.591 5.63638 113.703 10.2214 112.503 14.6992C111.303 19.1769 107.182 22.0917 102.739 21.9429C103.386 22.288 104.082 22.5652 104.82 22.7631Z",
    fill: "#585D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersHeroEmptyStateIcon);
export default __webpack_public_path__ + "static/media/filters-hero-empty-state-icon.be9614c55883d1307b52877fd0d33dd7.svg";
export { ForwardRef as ReactComponent };